// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"FormModal_backdrop__3YHim","modal":"FormModal_modal__1dVIt","header":"FormModal_header__103Y-","content":"FormModal_content__1Y3X3","actions":"FormModal_actions__1PxVl"};